import { first } from 'rxjs/operators'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { Collaborator } from '@skinsoft/types'
import { aliasSelectors } from '@skinsoft/selectors'
import { AliasDataStore as CollaboratorDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    components: {

    },
    props: ['collaboratorId'],
    template: require('./collaborator-view.html')
})
export class CollaboratorView extends ReactiveVue {

    public collaboratorId: string;
    private collaborator: Collaborator = null as any;


    private $collaboratorDataStore: CollaboratorDataStore;
    private subscribe() {

        if (this.collaboratorId) {
            this.subscribeTo(
                this.$collaboratorDataStore.fetchOne(this.collaboratorId)
                    .pipe(first()),
                collaborator => {
                    if (collaborator) {
                        this.collaborator = collaborator;
                    }
                }
            )
        }

    }

    private get formattedCollaboratorName() {
        let result = "";
        const firstName = aliasSelectors.firstName(this.collaborator, this.$i18n.locale)
        const lastName = aliasSelectors.lastName(this.collaborator, this.$i18n.locale)
        if (firstName) {
            result += firstName;
        }
        if (firstName && lastName) {
            result += " ";
        }
        if (lastName) {
            result += lastName
        }
        return result;
    }

    @Watch('collaboratorId', { immediate: true })
    private onCollaboratorIdChange() {
        this.unsubscribeFrom('collaborator-subscription')
        this.subscribe()
    }

}